export default {
  install (Vue, options) {
    //Vue.component() -- Register payment form component
    Vue.$vrPay = new Vue() //Register event bus
    Vue.blah = "Test"
  }
}



// WEBPACK FOOTER //
// ./src/plugins/vue-vrpay/index.js